// extracted by mini-css-extract-plugin
export default {"NavHeader":"NavHeader_NavHeader__1m846"};